module.exports = __webpack_public_path__ + "assets/images/albom2.6a84ee73.jpg";